import React, { useEffect } from 'react'
import styles from './HomeRemedies.module.css'
import styles1 from '../ArticleComponents/Common.module.css'
import ArticleCoverAndHeader from '../ArticleComponents/ArticleCoverAndHeader'
import Row from '../ArticleComponents/Row'

function HomeRemedies() {

    useEffect(() => {
        window.scroll({
          top: 0, 
          left: 0, 
          behavior: 'smooth'
        });
      })

      const rows = [
        {
          heading:"General Measures",
          listItem: [
            "Drink warm water throughout the day.",
           "Daily practice of Yogasana, Pranayama and meditation for at least 30 minutes",
           "Spices like Haldi (Turmeric), Jeera (Cumin), Dhaniya (Coriander) and Lahsun (Garlic) are recommended in cooking."
          ]
        },
        {
          heading:"Ayurvedic Immunity Promoting Measures",
          listItem: [
            "Take Chyavanprash 10gm (1tsf) in the morning. Diabetics should take sugar free Chyavanprash.",
           "Drink herbal tea / decoction (Kadha) made from Tulsi (Basil), Dalchini (Cinnamon), Kalimirch (Black pepper), Shunthi (Dry Ginger) and Munakka (Raisin) - once or twice a day. Add jaggery (natural sugar) and / or fresh lemon juice to your taste, if needed",
           "Golden Milk- Half tea spoon Haldi (turmeric) powder in 150 ml hot milk - once or twice a day"
          ]
        },{
          heading:"During dry cough / sore throat ",
          listItem: [
            "Steam inhalation with fresh Pudina (Mint) leaves or Ajwain (Caraway seeds) can be practiced once in a day.",
           "Lavang (Clove) powder mixed with natural sugar / honey can be taken 2-3 times a day in case of cough or throat irritation",
           "These measures generally treat normal dry cough and sore throat. However, it is best to consult doctors if these symptoms persist."
          ]
        }
      ]

      const receipes = [
        {
          title:"Tusli ka Kadha ",
          description:"This homemade tulsi kadha for immunity might help improve your digestion as well. It might offer relief from any kind of cold or flu. This can be taken 1-2 times a day.",
          Ingredients: "4-5 Tulsi leaves, 1 Ginger, 3-4 Raisins, Black pepper powder (1/4 teaspoon), Cinnamon powder (1/2 teaspoon)",
          howTo: ["Add two glasses of water in a pan", "Add tulsi, black pepper powder, cinnamon powder, ginger and raisin","Stir this mixture and let it boil for around 15 mins","Let it cool down for a while and then strain it using a strainer"]
        },{
          title:"Giloy ka Kadha",
          description:"This is considered to be one of the most effective homemade drinks to fight infections. Giloy is widely known for its health benefits as it helps boost immunity and fight free radicals. Giloy contains various anti-inflammatory properties and its regular intake might help control blood sugar levels too.",
          Ingredients: "Small branches of giloy (2), Holy basil leaves (7-8), Neem leaves (6-7), Cloves(5), Whole peppercorns (6), Ginger (1)",
          howTo:["Peel the giloy and chop it into small pieces","Add it along with all the ingredients","Add 2 glasses of water and blend it together","Heat the smooth paste in pan on medium flame","Add 2 glasses of water again and boil it","Wait till the kadha is reduced to half and then strain it."]
        },{
          title:"Dashmool Kadha",
          description:"This homemade kadha for immunity contains various anti-oxidant and anti-inflammatory properties. It may offer relief from inflammation and may even improve your overall health and well-being. You can have this dashmool kadha 1-2 times a day.",
          Ingredients: "Dashmool powder, Water",
          howTo:["Add 1-2 spoon of dashmool powder in one glass of water","Boil this mixture until it is reduced to half","Filter and strain it using a strainer"]
        },{
          title:"Ginger and apple cider vinegar kadha",
          description:"Ginger offers various benefits and may offer relief from cold and fever. Apple cider vinegar offers various health benefits that makes it one of the best homemade drinks to fight infections",
          Ingredients:"1 cup of Water, Ginger, Apple cider vinegar, Raw honey, Cayenne pepper",
          howTo:["Boil 1 cup of water for sometime","Add peeled and grated ginger","Cover and steep it for 5 mins","Add 1 teaspoon apple cider vinegar, 1 teaspoon raw honey and a pinch of cayenne pepper","Mix it and drink when warm"]
        },{
          title:"Dalchini kadha",
          description: "Also known as cinnamon, dalchini is known to contain various medicinal properties. It is loaded with a wide variety of anti-oxidants and contains several anti-inflammatory properties",
          Ingredients:"Cinnamon powder, Water, Honey",
          howTo:["Take half teaspoon of cinnamon powder","Add it in a cup of water and boil it for sometime","Add a teaspoon of honey and drink this kadha for immunity"]
        }
      ]

      const refList ={
          heading: "More Receipes on youtube",
          linkList: [
            {linkTitle:"3 ayurvedic immunity booster drink",link:"https://www.youtube.com/watch?v=dWThOggmOCw"},
          {linkTitle:"Home Made Kadha To Boost Immunity",link:"https://www.youtube.com/watch?v=lgJqff0bk30"},
          {linkTitle:"6 immune booster beverages",link:"https://www.youtube.com/watch?v=wbagj-fjWfw"},
          {linkTitle:"Immunity boosting diet for covid",link:"https://www.youtube.com/watch?v=jU9BsoHZuiM"}
        ]
        }

    return (
        <ArticleCoverAndHeader readTime={6} title="Home Remedies To Boost Immunity" author="Anushka Dixit"
        authorLink="https://www.instagram.com/anushkadixit1708/" previousGuide="/precautions" nextGuide="/donate-plasma">
        <img
          className={styles1.articleFirstImage}
          src="https://drive.google.com/thumbnail?id=1icBroCW-z1cv7Nt45h0-qVCwy3PhtUcm"
          alt="first_landscape_img"
        />

        <div className={styles1.introPara}>
          <p>
            In the wake of the second Covid 19 outbreak, people all across the country are suffering.
            Enhancing the body’s natural defence system (immunity) plays an important role in
            maintaining optimum health. While treating the virus at home is not possible, certain
            <span className={styles.highlight}>measures can be taken to fight the symptoms and accelerate healing</span>.
            Here are some measures recommended by the ministry of AAYUSH to help you fight this
            virus better:
          </p>
        </div>

        {rows.map((row) => (
          <Row row={row} />
        ))}

        <h2 className={styles1.sliderHeader} style={{fontWeight:700,color:"darkgreen"}}>
        Here are some recipes for home-made decoctions (Kadha)
      </h2>

      <div className={styles.column}>
        <ol className={styles.list}>
      { receipes.map(receipe => (
        
          <li>
            <span className={styles.highlight}>{receipe.title} : </span>
            {receipe.description}
            <ul className={styles.listInner}>
              <br/><li><span className={styles.highlight}>Ingredients : </span><br/>{receipe.description}</li><br/>
              <li><span className={styles.highlight}>How to prepare : </span><br/></li>
              {
                receipe.howTo.map(points => (<li style={{listStyleType:"circle  ",marginLeft:"15px"}}>{points}</li>))
              }
              
            </ul>
          </li>
          
        
        ))
        
      }
      </ol>
        </div>
        <Row row={refList} links/>
        </ArticleCoverAndHeader>
    )
}

export default HomeRemedies
